<template>
  <div class="view">
    <v-container fluid>
      <v-row>
        <v-col>
          <router-link to="/report">กลับหน้ารายงาน</router-link>
        </v-col>
        <v-col class="text-right">
          <DatePickerMonth :dateFrom="dateFrom" :dateTo="dateTo" :onApply="onChangeDate"></DatePickerMonth>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-simple-table class="overview-list" dense>
            <template v-slot:default>
              <tbody>
              <tr>
                <td>สถานะ</td>
                <td class="text-right">จำนวน</td>
                <td class="text-right">ยอดขาย</td>
                <td class="text-right">ยอดหาร
                </td>
              </tr>
              <tr v-for="(item, index)  in summary_so" :key="index">
                <td>{{OrderConst.map(item.status)}}</td>
                <td class="text-right" :class="item.css">{{ $helper.number_format(item.total_count,0) }} ใบ</td>
                <td class="text-right" :class="item.css">{{ $helper.number_format(item.total_so,0) }} บาท</td>
                <td class="text-right" :class="item.css">{{ $helper.number_format(item.total_share,0) }} บาท
                </td>

              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-col>
        <v-col class="text-right">
          <div class="summary">
            ยอดรวม ex.vat {{$helper.number_format(summary.total_gross,2,2)}} บาท<br/>
            <span v-if="summary.commission_value">
            ยอดรวมคอมฯ {{$helper.number_format(summary.commission_value,2,2)}} บาท
          </span>
          </div>
        </v-col>
      </v-row>

      <v-data-table
          v-if="orders && Array.isArray(orders)"
          :headers="headers"
          :items="orders"
          :options.sync="options"
          :server-items-length="totalRecords"
          :loading="loading"
          @click:row="viewOrder"
          class="elevation-1 tr-clickable"
      >

        <template v-slot:item.erp_so_at="{ item }">
          {{ item.erp_so_at?$helper.date_format_short(item.erp_so_at):
          (item.submitted_at?$helper.date_format_short(item.submitted_at):'')
          }}
        </template>
        <template v-slot:item.status="{ item }">
          {{OrderConst.map(item.status)}}
        </template>
        <template v-slot:item.customer="{ item }">
          {{item.code}}<br/>
          {{item.customer?item.customer.nickname:item.customer_code}}<br/>
        </template>
        <template v-slot:item.total_gross="{ item }">
          {{ $helper.number_format(item.total_gross,2,2) }}
        </template>
        <template v-slot:item.commission_value="{ item }">
          <span v-if="item.sales && item.sales[0] &&  item.sales[0]['commission_value']>0">
             {{ $helper.number_format(item.sales[0]['commission_value'],2,2) }}
          </span>
          <span v-else>
             {{ $helper.number_format(item.total_commission_able,2,2) }}
          </span>
        </template>
        <template v-slot:item.total_external_discount="{ item }">
          <span v-if="!item.sales || !item.sales[0] || item.sales[0]['user_code']===item.primary_sale">
             {{ $helper.number_format(item.total_external_discount,2,2) }}
          </span>
        </template>
      </v-data-table>

    </v-container>
  </div>
</template>
<style scoped>

  .view {
    font-size: 18px;
  }

  .right-box {
    height: 30vh;
  }

  .right-col {
    padding-top: 0;
    padding-bottom: 0;
  }

  .right-container {
    padding: 0;
  }

  .bold {
    font-weight: bold;
  }

  .overview-list {
    background: transparent;
  }
</style>
<script lang="ts">

  import {Component, Vue, Watch} from 'vue-property-decorator'
  import LoadingDummy from '../../components/LoadingDummy.vue'
  import DatePickerMonth from '../../components/Util/DatePickerMonth.vue'
  import {Order, OrderConst} from '../../models/Order'
  import {DataArray} from '../../models/Response'

  import Helper from '../../services/Helper.js'

  @Component({
    components: {DatePickerMonth, LoadingDummy},
  })
  export default class ViewReportSaleSoFar extends Vue {
    search = ''

    OrderConst = OrderConst
    orders: Order[] = []

    dateFrom: string = '1970-01-01'
    dateTo: string = '1970-01-01'

    selectedOrder: Order | null = null
    summary = {
      total_gross: 0,
      commission_value: 0,
      count_records: 0,
    }

    summary_so = [
      {label: 'Loading', total_count: 0, total_so: 0, total_share: 0},
    ]

    totalRecords = 0

    loading = true
    options = {
      groupBy: [],
      groupDesc: [],
      itemsPerPage: 5,
      multiSort: false,
      mustSort: false,
      page: 1,
      sortBy: ['erp_so_at'],
      sortDesc: [0],
    }
    // options = {
    //   page: 1,
    //   itemsPerPage: 10,
    //   sortBy: 'order',
    //   sortDesc: true,
    // }
    headers = [
      // {text: 'order', value: 'code'},
      {text: 'สั่ง', value: 'erp_so_at'},
      {text: 'สถานะ', value: 'status'},
      {text: 'ลูกค้า', value: 'customer'},
      {text: 'จังหวัด', value: 'customer.province'},
      {text: 'ยอด ex.vat', value: 'total_gross', align: 'end'},
      {text: 'ยอดหาร', value: 'commission_value', align: 'end'},
      {text: 'ลดนอก', value: 'total_external_discount', align: 'end'},
    ]

    @Watch('options')
    onOptionChanged() {
      this.reload()
    }


    mounted() {
      // console.log('this.dateFrom',this.dateFrom);
      let tzoffset = (new Date()).getTimezoneOffset() * 60000

      if (this.$route.params.month) {
        if (this.$route.params.month == 'previous') {
          var tmpDateFrom = new Date(Date.now())
          tmpDateFrom.setDate(0)
          this.dateTo = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
          tmpDateFrom.setDate(1)
          this.dateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
        }
      } else {
        let tmpDateFrom = new Date(Date.now())
        tmpDateFrom.setDate(1)
        const strDateFrom = (new Date(tmpDateFrom.getTime() - tzoffset))
        this.dateFrom = strDateFrom.toISOString().substr(0, 10)

        let startOfMonth = (new Date(Date.now() - tzoffset))
        this.dateTo = startOfMonth.toISOString().substr(0, 10)
      }

    }

    onChangeDate(dateFrom, dateTo) {
      this.dateFrom = dateFrom
      this.dateTo = dateTo
      this.reload()
    }

    reload() {
      let url = Helper.setting.order.getListAPI

      const {sortBy, sortDesc, page, itemsPerPage} = this.options

      let option = ''
      option += `&summary=1`

      if (sortDesc.length > 0) {
        option += `&sortDesc=${sortDesc[0]}`
      }


      option += `&status=` + [
        OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO,
        OrderConst.STATUS_DO_CONFIRMED_WAIT_STOCK,
        OrderConst.STATUS_STOCK_DEBITED_WAIT_START_DELIVERY,
        OrderConst.STATUS_DELIVERY_STARTED,
        OrderConst.STATUS_DELIVERY_SUCCESS,
        OrderConst.STATUS_DELIVERY_FAILED,
        OrderConst.STATUS_INVOICED,
        OrderConst.STATUS_PAID,
      ].join()

      if (this.dateFrom && this.dateTo) {
        option += `&com_from_date=${this.dateFrom}&com_to_date=${this.dateTo}`
      }
      //
      if (page) {
        option += `&page=${page}`
      }
      if (itemsPerPage) {
        option += `&page_size=${itemsPerPage}`
      }


      if (option != '') {
        url = url + '?' + option.substr(1)
      }


      console.log('getUrlFilter', url)

      Helper.get(url)
        .then<{ data: DataArray }>(({data}) => {

          this.orders = data.data
          if (data.meta.total) {
            this.totalRecords = data.meta.total
          }

          if (data.summary) {
            this.summary = data.summary
            if (data.summary.summary_so) {
              this.summary_so = data.summary.summary_so
            }
          }

          this.loading = false
        }).catch(() => {
      })
    }

    viewOrder(item, debug) {
      this.$root.$emit('openOrder', {order: item, orders: this.orders, debug: debug})
    }
  }
</script>
